import React, { ReactNode } from 'react';
import { Dialog } from '@mui/material';
import { DialogProps } from '@mui/material/Dialog/Dialog';

export interface EditorModalContentProps {
  closeModal: () => void;
}

export interface EditorodalProps {
  isOpen: boolean;
  closeModal: () => void;
  children: ReactNode;
  dialogProps?: Partial<DialogProps>;
}

export function EditorModal({
  isOpen,
  closeModal,
  children,
  dialogProps,
}: EditorodalProps): React.ReactElement {
  return (
    <Dialog
      open={isOpen}
      onClose={() => {
        closeModal();
      }}
      // TOOD how to make this customizable
      maxWidth="xl"
      fullWidth
      {...dialogProps}
    >
      {children}
    </Dialog>
  );
}
